import { allowedMimeTypes, maxSizeInBytes } from "../constants";

export const formatSentenceCase = (string) => {
    if (typeof string !== 'string') return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const isValidFileType = (file) => {
    const isValidMimeType = allowedMimeTypes.includes(file.type ?? '');  
    return isValidMimeType;
}

export const isValidFileSize = (file) => {
    const isValidFileSize = file.size <= maxSizeInBytes;
    return isValidFileSize;
}

export const isValidUrlParamFields = (urlParams, requiredFields) => {
    const checkKeys = Object.keys(urlParams)
    for (let key of requiredFields) {
        if (!checkKeys.includes(key) || !urlParams[key]) {
            return false;
        }
    }
    return true;
}

export const getClassValue = (classValue) => {
    const value =  parseInt(classValue, 16);

    if (value === 66) { // ASCII 66 = B = Bronze
        return 'Bronze';
    } else if (value === 83) { // ASCII 83 = S = Silver
        return 'Silver';
    } else if (value === 71) { // ASCII 71 = G = Gold
        return 'Gold';
    } else if (value === 80) { // ASCII 80 = P = Platinum
        return 'Platinum';
    } else {
        return '';
    }
}

// Classes A70 and B70 use the same package codes, named with a 70 suffix (e.g. Bronze70)
export const getClass70Value = (classValue) => {
    const value = getClassValue(classValue);
    return value ? `${value}70` : '';
}

export const getClassLivesValue = (lives) => {
    const value =  parseInt(lives, 16);
    if (value.toString() === 'NF' || lives === '0' || !lives) {
        return '';
    } else {
        return value.toString();
    }
}

export const getClassLTDValue = (classValue) => {
    const value =  parseInt(classValue, 16);
    
    if (value === 78) { // ASCII 78 = N = No
        return 'No';
    } else if (value === 89) { // ASCII 89 = Y = Yes
        return 'Yes';
    } else {
        return '';
    }
}

export const getCommissionValue = (commissionValue) => {
    if (commissionValue.slice(0, 2) === 'KX') { // KX = Standard
        return 'Standard';
    } else if (commissionValue.slice(0, 2) === 'LP') {  // LP = Special
        return 'Special';
    }
    
    const value = parseInt(commissionValue, 16);

    return value / 10000; // Convert to decimal
}

export const getEffectiveDateValue = (effectiveDateValue) => {
    const value = parseInt(effectiveDateValue, 16);

    const dateString = value.toString();
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);

    const date = `${year}-${month}-${day}`;

    return date;
}

export const getCustomCommissionValue = (commissionValue) => {
    if (commissionValue === 'Standard') {
        return 'Standard';
    } else if (commissionValue === 'Special') {
        return 'Custom';
    } else {
        return (Number(commissionValue) * 100).toFixed(2).toString();
    }
}

export const extractExpiryFromUrl = (urlSuffix) => {
    if (!urlSuffix || urlSuffix.length !== 10) {
        return null;
    }
    
    // Extract the left 7 characters (HEX encoded date)
    const hexDateValue = urlSuffix.substring(0, 7);
    
    try {
        // Convert HEX to DEC
        const decValue = parseInt(hexDateValue, 16);
        
        // Convert to string and validate format YYYYMMDD
        const dateString = decValue.toString();
        if (dateString.length !== 8) {
            return null;
        }
        
        const year = parseInt(dateString.substring(0, 4));
        const month = parseInt(dateString.substring(4, 6));
        const day = parseInt(dateString.substring(6, 8));
        
        // Validate date components
        if (year < 1900 || year > 3000 || month < 1 || month > 12 || day < 1 || day > 31) {
            return null;
        }
        
        // Create date object for validation
        const expiryDate = new Date(year, month - 1, day);
        if (expiryDate.getFullYear() !== year || 
            expiryDate.getMonth() !== month - 1 || 
            expiryDate.getDate() !== day) {
            return null;
        }
        
        return {
            expiryDate,
            formattedDate: `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`,
            isExpired: new Date() > expiryDate
        };
    } catch (error) {
        return null;
    }
}

export const isUrlExpired = (urlSuffix) => {
    const expiryInfo = extractExpiryFromUrl(urlSuffix);
    return expiryInfo ? expiryInfo.isExpired : true; // Treat invalid URLs as expired
}
